import EppoFlags from '@/EppoFlags';
import {useBooleanAssignment} from '@/eppoHooks';

/**
 * The `excludeModificationCarts` value every `openOrders` caller must pass. Apollo caches the
 * query per variables, so callers that disagree send two requests.
 */
const useExcludeModificationCarts = () =>
  useBooleanAssignment(EppoFlags.DraftCartDropdownExcludeOrderMods);

export default useExcludeModificationCarts;
